<template>
  <div class="flex flex-row progress mx-auto py-5">
    <div class="flex-1"><img :src="step1Img"></div>
    <div class="flex-1"><img :src="step2Img"></div>
    <div class="flex-1"><img :src="step3Img"></div>
  </div>
</template>

<script>
import dot from '@/assets/images/dot.svg'
import dotActive from '@/assets/images/dot_active.svg'

export default {
  name: 'StepProgress',
  props: {
    step: {
      default: 0
    }
  },
  computed: {
    step1Img(){
      if (this.step > 0) {
        return dotActive;
      }
      return dot;
    },
    step2Img(){
      if (this.step > 1) {
        return dotActive;
      }
      return dot;
    },
    step3Img(){
      if (this.step > 2) {
        return dotActive;
      }
      return dot;
    }
  }
}
</script>

<style scoped>
.progress {
  max-width: 120px;
}
</style>
